/**
 * Event Service
 * Historical events service API: a read-only record of what happened inside a Convercus loyalty program. It serves the stored event history for accounts, memberships and users, for coupons, for news posts and for workflows, filtered by subject, date range, originating user and event type. Every endpoint is a paginated read; the service never writes, edits or replays events.
 *
 * The version of the OpenAPI document: v1.0.37758
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CustomPropertyDto } from './custom-property-dto';


export interface UserDto { 
    /**
     * Unique identifier of the user
     */
    userId: string;
    /**
     * User program
     */
    program: string;
    /**
     * Email address
     */
    emailAddress?: string;
    /**
     * Given name of the user
     */
    givenName?: string;
    /**
     * Family name of the user
     */
    familyName?: string;
    /**
     * Street and house number
     */
    streetHouseNo?: string;
    /**
     * ZIP code
     */
    zipCode?: string;
    /**
     * City
     */
    city?: string;
    /**
     * Country code
     */
    countryCode?: string;
    /**
     * Gender code
     */
    genderCode?: UserDto.GenderCodeEnum;
    /**
     * Birth date
     */
    birthDate?: string;
    /**
     * Phone number
     */
    phone?: string;
    /**
     * List of custom properties
     */
    customProperties?: Array<CustomPropertyDto>;
}
export namespace UserDto {
    export type GenderCodeEnum = 'MALE' | 'FEMALE' | 'DIVERSE';
    export const GenderCodeEnum = {
        Male: 'MALE' as GenderCodeEnum,
        Female: 'FEMALE' as GenderCodeEnum,
        Diverse: 'DIVERSE' as GenderCodeEnum
    };
}


